//@flow
import React, { Component } from 'react';
import {
  LgDesktop,
  Desktop,
  Tablet,
  Default,
  Mobile
} from '../../../../components/Responsive';
import {
  ModelListTh,
  ModelRowTr,
  SpacerTd
} from '../../../../components/ModelListStyles';
import UpDownSwitch from '../../../../components/UpDownSwitch';
import InfoTooltip from '../../../../components/InfoTooltip';
import { SortableSwitchDiv } from '../../DirectMerchants/DirectMerchantsIndex/DirectMerchantsIndexStyles';

type Props = {
  showTooltip: string => void,
  activeTooltip: string,
  changeSortOrder: string => void,
  orderBy: string,
  orderDirection: string
};
export default class MerchantTransactionHead extends Component<Props> {
  render() {
    return (
      <thead>
        <ModelRowTr>
          <SpacerTd />
          <LgDesktop>
            <ModelListTh>ID #</ModelListTh>
            <ModelListTh>
              <SortableSwitchDiv
                onClick={() =>
                  this.props.changeSortOrder('commissions.created_at')
                }
              >
                Date
                <UpDownSwitch
                  upFillColor={
                    this.props.orderBy === 'commissions.created_at' &&
                    this.props.orderDirection === 'asc'
                      ? 'dustierGray'
                      : 'black'
                  }
                  downFillColor={
                    this.props.orderBy === 'commissions.created_at' &&
                    this.props.orderDirection === 'desc'
                      ? 'dustierGray'
                      : 'black'
                  }
                />
              </SortableSwitchDiv>
            </ModelListTh>
          </LgDesktop>
          <ModelListTh>Merchant</ModelListTh>
          <ModelListTh right>
            <SortableSwitchDiv
              onClick={() => this.props.changeSortOrder('transaction_amount')}
            >
              Processing Volume
              <UpDownSwitch
                upFillColor={
                  this.props.orderBy === 'transaction_amount' &&
                  this.props.orderDirection === 'asc'
                    ? 'dustierGray'
                    : 'black'
                }
                downFillColor={
                  this.props.orderBy === 'transaction_amount' &&
                  this.props.orderDirection === 'desc'
                    ? 'dustierGray'
                    : 'black'
                }
              />
            </SortableSwitchDiv>
          </ModelListTh>
          <LgDesktop>
            <ModelListTh right>
              <SortableSwitchDiv
                onClick={() => this.props.changeSortOrder('transaction_fee')}
              >
                Fees
                <UpDownSwitch
                  upFillColor={
                    this.props.orderBy === 'transaction_fee' &&
                    this.props.orderDirection === 'asc'
                      ? 'dustierGray'
                      : 'black'
                  }
                  downFillColor={
                    this.props.orderBy === 'transaction_fee' &&
                    this.props.orderDirection === 'desc'
                      ? 'dustierGray'
                      : 'black'
                  }
                />
              </SortableSwitchDiv>
            </ModelListTh>
          </LgDesktop>
          <Desktop>
            <ModelListTh>
              <InfoTooltip
                showTooltip={this.props.showTooltip}
                activeTooltip={this.props.activeTooltip}
                tooltipName={'MERCHANT_TRANSACTIONS_STATUS'}
                message="This indicates the status of the merchants transaction, not the status of your commission."
                mobileRightEdge
                smallIcon
              />{' '}
              Status
            </ModelListTh>
          </Desktop>
          <Tablet>
            <ModelListTh />
          </Tablet>
          <Default>
            <ModelListTh right>
              <SortableSwitchDiv
                onClick={() => this.props.changeSortOrder('revenue_share')}
              >
                Commission Earned
                <UpDownSwitch
                  upFillColor={
                    this.props.orderBy === 'revenue_share' &&
                    this.props.orderDirection === 'asc'
                      ? 'dustierGray'
                      : 'black'
                  }
                  downFillColor={
                    this.props.orderBy === 'revenue_share' &&
                    this.props.orderDirection === 'desc'
                      ? 'dustierGray'
                      : 'black'
                  }
                />
              </SortableSwitchDiv>
            </ModelListTh>
          </Default>
          <Mobile>
            <ModelListTh />
          </Mobile>
          <SpacerTd />
        </ModelRowTr>
      </thead>
    );
  }
}
